module.exports = __webpack_public_path__ + "assets/img/box-5.9ec46abe.png";